import LegalPage from "@/components/LegalPage";

const CONTENT = {
  en: {
    overline: "Legal — Privacy",
    title: "Privacy Policy",
    intro:
      "This policy explains how GADULABS YAZILIM LİMİTED ŞİRKETİ (\u201CGADULABS\u201D) handles personal data in connection with this website.",
    chapters: [
      {
        title: "Data controller",
        text: "GADULABS YAZILIM LİMİTED ŞİRKETİ, Mustafa Kemal Paşa Mah. Yalova-Bursa Yolu Cad. A Blok 1. Kademe No: 123/1, İç Kapı No: 10, Merkez / Yalova, Türkiye. Contact: info@gadulabs.com.",
      },
      {
        title: "What we collect",
        text: "This website does not operate user accounts, forms or newsletters. If you contact us by email, we process the data you provide — name, email address and message content — solely to respond. This website does not use visitor analytics or session recording. Hosting and font providers may process technical request data needed to deliver the site, such as IP addresses and browser information.",
      },
      {
        title: "Legal basis",
        text: "Depending on your location, processing is based on our legitimate interest in operating and improving this website and responding to inquiries, under applicable law including the Turkish Personal Data Protection Law (KVKK, Law No. 6698) and, where relevant, the GDPR.",
      },
      {
        title: "Sharing",
        text: "We do not sell personal data. Data is shared only with service providers strictly necessary to operate the website and our email infrastructure.",
      },
      {
        title: "Retention",
        text: "Email correspondence is kept only as long as needed to handle your inquiry and any reasonable follow-up.",
      },
      {
        title: "Your rights",
        text: "You may request access to, correction or deletion of your personal data, or object to its processing, at any time by contacting info@gadulabs.com.",
      },
      {
        title: "Changes",
        text: "We may update this policy from time to time. The current version is always published on this page.",
      },
    ],
    footnote: "GADULABS YAZILIM LİMİTED ŞİRKETİ — Yalova, Türkiye",
  },
  tr: {
    overline: "Yasal — Gizlilik",
    title: "Gizlilik Politikası",
    intro:
      "Bu politika, GADULABS YAZILIM LİMİTED ŞİRKETİ'nin (\u201CGADULABS\u201D) bu web sitesiyle bağlantılı olarak kişisel verileri nasıl işlediğini açıklar.",
    chapters: [
      {
        title: "Veri sorumlusu",
        text: "GADULABS YAZILIM LİMİTED ŞİRKETİ, Mustafa Kemal Paşa Mah. Yalova-Bursa Yolu Cad. A Blok 1. Kademe No: 123/1, İç Kapı No: 10, Merkez / Yalova, Türkiye. İletişim: info@gadulabs.com.",
      },
      {
        title: "Hangi verileri işliyoruz",
        text: "Bu web sitesi kullanıcı hesabı, form veya bülten içermez. Bize e-posta ile ulaşırsanız, sağladığınız verileri — ad, e-posta adresi ve mesaj içeriği — yalnızca yanıt vermek amacıyla işleriz. Bu sitede ziyaretçi analitiği veya oturum kaydı kullanılmaz. Barındırma ve yazı tipi sağlayıcıları, siteyi sunmak için gereken IP adresi ve tarayıcı bilgisi gibi teknik istek verilerini işleyebilir.",
      },
      {
        title: "Hukuki dayanak",
        text: "Konumunuza bağlı olarak işleme; web sitesini işletme ve iyileştirme ile taleplere yanıt verme konusundaki meşru menfaatimize dayanır. 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili olduğu ölçüde GDPR uygulanır.",
      },
      {
        title: "Paylaşım",
        text: "Kişisel verileri satmayız. Veriler yalnızca web sitesinin ve e-posta altyapımızın işletilmesi için zorunlu olan hizmet sağlayıcılarla paylaşılır.",
      },
      {
        title: "Saklama",
        text: "E-posta yazışmaları yalnızca talebinizin ve makul takiplerin gerektirdiği süre boyunca saklanır.",
      },
      {
        title: "Haklarınız",
        text: "Kişisel verilerinize erişme, düzeltilmesini veya silinmesini talep etme ya da işlenmesine itiraz etme hakkınızı dilediğiniz zaman info@gadulabs.com adresine yazarak kullanabilirsiniz.",
      },
      {
        title: "Değişiklikler",
        text: "Bu politikayı zaman zaman güncelleyebiliriz. Güncel sürüm her zaman bu sayfada yayınlanır.",
      },
    ],
    footnote: "GADULABS YAZILIM LİMİTED ŞİRKETİ — Yalova, Türkiye",
  },
};

export default function PrivacyPage() {
  return <LegalPage content={CONTENT} testid="privacy" />;
}
